var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75H9C8.30964 12.75 7.75 13.3096 7.75 14C7.75 14.6904 8.30964 15.25 9 15.25H19C19.6904 15.25 20.25 14.6904 20.25 14Z",
    fill: "#4B4B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 27.75C21.5939 27.75 27.75 21.5939 27.75 14C27.75 6.40608 21.5939 0.25 14 0.25C6.40608 0.25 0.25 6.40608 0.25 14C0.25 21.5939 6.40608 27.75 14 27.75ZM14 25.2415C7.79151 25.2415 2.75854 20.2085 2.75854 14C2.75854 7.79151 7.79151 2.75854 14 2.75854C20.2085 2.75854 25.2415 7.79151 25.2415 14C25.2415 20.2085 20.2085 25.2415 14 25.2415Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.20a595c7e5693f6085fb9900a61a8356.svg";
export { ForwardRef as ReactComponent };